import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, CalendarCheck, LineChart, PlugZap, Sparkles } from 'lucide-react';
import { LANDING_LINKS } from '../pages/UseCaseLanding';

const ICONS = [CalendarCheck, Sparkles, LineChart, PlugZap];

export const UseCaseLinksSection: React.FC = () => {
  return (
    <section className="py-20 bg-slate-50 border-y border-slate-100">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="text-emerald-700 font-bold uppercase tracking-widest text-sm">Casos de uso</span>
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tight mt-3 mb-4">
            Mira cómo aplica Ancora a tu negocio concreto
          </h2>
          <p className="text-slate-500 text-lg leading-relaxed">
            La home explica la visión completa. Estas páginas aterrizan el flujo por tipo de cliente, problema e integración.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {LANDING_LINKS.map((landing, index) => {
            const Icon = ICONS[index] || Sparkles;
            return (
              <motion.div
                key={landing.path}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
              >
                <Link
                  to={landing.path}
                  className="group block h-full rounded-3xl bg-white border border-slate-100 p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="w-12 h-12 rounded-2xl bg-emerald-50 flex items-center justify-center mb-5 group-hover:bg-emerald-100 transition-colors">
                    <Icon size={24} className="text-emerald-700" />
                  </div>
                  <div className="text-emerald-700 text-xs font-bold uppercase tracking-widest mb-3">
                    {landing.eyebrow}
                  </div>
                  <h3 className="text-lg font-black text-slate-900 leading-snug mb-3">
                    {landing.title}
                  </h3>
                  <p className="text-slate-500 text-sm leading-relaxed mb-5">
                    {landing.description}
                  </p>
                  <span className="inline-flex items-center gap-2 text-sm font-bold text-emerald-700">
                    Ver caso de uso
                    <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
